import { customType } from 'drizzle-orm/sqlite-core'
import { z } from 'zod'

export enum PermissionRole {
  VIEWER = 'viewer',
  EDITOR = 'editor',
  SCHEDULER = 'scheduler',
  PUBLISHER = 'publisher',
  ADMIN = 'admin'
}

const roleColors: Record<PermissionRole, string> = {
  [PermissionRole.VIEWER]: 'bg-slate-500/20 text-slate-400 border-slate-500/30',
  [PermissionRole.EDITOR]: 'bg-primary/20 text-primary border-primary/30',
  [PermissionRole.SCHEDULER]: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
  [PermissionRole.PUBLISHER]: 'bg-gray-500/20 text-gray-400 border-gray-500/30',
  [PermissionRole.ADMIN]: 'bg-blue-500/20 text-blue-400 border-blue-500/30'
}

export const getPermissionRoleColor = (role: PermissionRole) => roleColors[role]
export const getIsOwnerColor = () => 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30'

export const permissionRoleSchema = z.enum(PermissionRole)

/** Column type for permission role; nullable when user has a custom role. */
export const permissionRoleType = customType<{ data: PermissionRole | null, driverData: string | null }>({
  dataType() {
    return 'text'
  },
  fromDriver(value) {
    if (value == null) { return null }
    if (typeof value === 'string' && Object.values(permissionRoleSchema.enum).includes(value as PermissionRole)) {
      return value as PermissionRole
    }
    throw new TypeError(`Invalid permission role: ${value}}`)
  },
  toDriver(value) {
    return value == null ? null : (value as PermissionRole)
  }
})
